import BoxSpoiler from './box-spoiler';

export default BoxSpoiler;
